import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import NavBarContainer from '../common/NavBarContainer';
import getRoleGroupByRole from '../../utils/dashboard/getRoleGroupbyRole';
import { USER_GROUPS, ALL_USER_ROLES } from '../../constants/roles/userRoleTypes';
import { configs } from '../../constants/configs/configs';
import {
    fields,
    labelNames,
    filtersByRole,
    tableHeadersByRole,
    headersByType
} from '../../constants/entity/entityConfig';
import {
    fetchAssisterData,
    initAssisterFilters,
    setFilterValue,
    resetFilterValues,
    fetchNavBarData ,
    exportAssisterBob,
    fetchEntitySiteList,
    setFilterFormState,
    setExportBtnState,
    setCurrentAssister
} from '../../actions/entity/entityActionCreator';
import AssisterList from '../../components/entity/AssisterList';
import { useIntl } from 'react-intl/dist';
import validators from '../../utils/validators/validators';
import { VALIDATION_TYPES } from '../../constants/inputs/validationTypes';

const EntityExportContainer = props => {
    const { endpoints } = configs;
    const {
        actions,
        spinner,
        environment: {
            isState,
            impersonation,
            impersonationDetails,  
            user: {
                role
            }            
        },
        entity: {
            list,
            filters,            
            pagination,
            validation                    
        }
    } = props;
    const intlApi = useIntl();
    const roleGroup = !impersonation ? getRoleGroupByRole(role) : getRoleGroupByRole(impersonationDetails.role);
    const containerWidth = 'grid-col-12';
    const createFilterObj = arr => arr.reduce((o, key) => ({ ...o, [key]: { value : '' } }), {});
    const filtersData = createFilterObj(filtersByRole[roleGroup]);
    const [pageNumber, setPageNumber] = useState(0);    
    //const [assisterId, setCurrentAssisterId] = useState(0);
    const [firstPageLoad,setFirstPageload] = useState(true);

    const exportBOBEndpoint = isState.CA ? endpoints.CEC_EXPORT_BOB : endpoints.CEC_EXPORT_BOB_NON_CA;

    const createTableHeaders = arr => arr.map(item => {                
        if (headersByType[item]) {
            return ({ 
                'id': item, 
                'text': intlApi.formatMessage({ id: labelNames[item] }), 
                'type': headersByType[item], 
                'handler':`${exportBOBEndpoint.processReplacements( { assisterId : ( pagination.selectedAssister ? pagination.selectedAssister.encryptedId : 0) } )}`,
                'classes':'gi-button gi-button__primary btn export-btn' + (validation.exportBtnDisable ? ' disabled' : ''),
                'columnParentClasses':'pull-right margin-x-2'

            });
        }else{
            return ({ 'id': item, 'text': intlApi.formatMessage({ id: labelNames[item] }) });
        }
        
    });    

    const onAssisterChange = assister => {                         
        actions.setCurrentAssister(assister);
        actions.setExportBtnState( { isDisable : false } );
    };

    const tableHeadersData = tableHeadersByRole[roleGroup];
    const getAllowedUserRolesForNavBar = () => {
        const allowedUserRoles = [
            USER_GROUPS.AGENCY_GROUP,
            ALL_USER_ROLES.BROKER,
            ALL_USER_ROLES.ASSISTER,
            ALL_USER_ROLES.ASSISTERENROLLMENTENTITY
        ];

        !isState.CA && allowedUserRoles.push(USER_GROUPS.CSR_GROUP);

        return allowedUserRoles;
    };
    /**
     * Filter input onChange handler. Dispatches action to save values to a redux store.
     * @param e
     */

    const onChangeHandler = e => {
        const { name, value } = e.target;
        if(name === 'emailAddress'){
            let isValid  = false;
            const re = /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if(value === '' || (value !== '' && re.test(value))){
                isValid = true;
            }
            actions.setFilterValue({ fieldName : name, fieldValue : value , isVisible : !isValid });
        }
        else if(validateInput(name,value)){
            actions.setFilterValue({ fieldName : name, fieldValue : value });
        }
    };

    const validateInput = (name,value) => {
        let isValid = false;
        if(name=== 'assisterNumber'){
            const re = /^[0-9\b]+$/;
            if((value === '' || (value !== '' && re.test(value)))){
                isValid = true;
            }else{
                isValid = false;
            }
        }else if(name === 'firstName' || name === 'lastName'){
            const re = /^[a-z0-9 \-_']+$/i;
            if((value === '' || (value !== '' && re.test(value)))){
                isValid = true;
            }else{
                isValid = false;
            }
        }else{
            return isValid = true;
        }
        return isValid;
    };
    /**
     * Collects values from all filters, constructs query param string and fetches new delegation data.
     */
    const onApplyHandler = () => {        
        const isValid = validateFilters(filters);
        if(isValid){

            actions.setFilterFormState({
                [fields.CEC_EMAIL] : { isVisible : false }
            });

            const params = constructQueryParams(filters);
            const queryParams = params && `&${params}`;                    
            actions.fetchAssisterData(`${endpoints.SEARCH_CEC.processReplacements({ pageNumber: 1 })}${queryParams}`);
            //actions.fetchAssisterData(`${endpoints.SEARCH_CEC}`);
            setPageNumber(0);
            actions.setCurrentAssister(null);
            actions.setExportBtnState( { isDisable : true } );	
            setFirstPageload(false);
        }else{
            actions.setFilterFormState({
                [fields.CEC_EMAIL] : { isVisible : true }
            });
        }
        
    };

    const validateFilters = ( filterValues ) => {
        const validator = validators.find(validator => validator.validatorType === VALIDATION_TYPES.EMAIL );
        let isValid = true;
        if(filterValues[fields.CEC_EMAIL].value != null && filterValues[fields.CEC_EMAIL].value != '' && !validator.verifier({ value : filterValues[fields.CEC_EMAIL].value } )) {
            isValid = false;
        }
        return isValid;
    };
    /**
     * Clears filters to initial state and updates redux store.
     */
    const onResetHandler = () => {
        actions.resetFilterValues(filtersData);
        setPageNumber(0);
        actions.fetchAssisterData(`${endpoints.SEARCH_CEC.processReplacements({ pageNumber: 1 })}`);
        actions.fetchEntitySiteList(`${endpoints.ENTITY_SITE_LIST}`);
        actions.setExportBtnState( { isDisable : true } );	
        setFirstPageload(false);
    };
    /**
     * Makes a new call to fetch new set of data.
     * @param data
     */
    const onPageNumberChange = data => {
        const params = constructQueryParams(filters);
        const queryParams = params && `&${params}`;
        setPageNumber(data.selected);                
        actions.fetchAssisterData(`${endpoints.SEARCH_CEC.processReplacements({ pageNumber: data.selected + 1 })}${queryParams}`);
        //actions.setExportBtnState( { isDisable : true } );
    };
    /**
     * Formats delegation history table data: concats firstName and lastName.
     * @param assisterList
     * @returns {[]}
     */
    const processedTableData = (assisterList) => {
        let result = [];        
        let selectedAssisterNumber = pagination.selectedAssister ? pagination.selectedAssister.assisterNumber : 0 ;                
        
        assisterList.forEach(row => {
            let processedRow = {};
            for (let headerName of tableHeadersData) {
                switch (headerName) {
                    case fields.CEC_RD_BTN:{                       
                        processedRow[headerName] =  <span><input type="radio" name="id" checked={ row.assisterNumber ===  selectedAssisterNumber }  value={row.encryptedId} onClick={()=>{onAssisterChange(row);}}/></span>;
                        break;
                    }                    
                    case fields.CEC_NAME: {
                        processedRow[headerName] =  <span>{row.firstName} {row.lastName}</span>;
                        break;
                    }
                    case fields.CEC_EMAIL: {
                        processedRow[headerName] = row[headerName] ? row[headerName]  : '-';
                        break;
                    }
                    case fields.CEC_LICENCE_NUMBER: {
                        processedRow[headerName] = !row[headerName] ? '-' : row[headerName];
                        break;
                    }
                    case fields.PRIMARY_SITE:{
                        const  siteAddress = row.primaryAssisterSite ? ( (row.primaryAssisterSite.physicalLocation.address1 ? row.primaryAssisterSite.physicalLocation.address1 : ' ')
                        + (row.primaryAssisterSite.physicalLocation.address2 ? ', ' + row.primaryAssisterSite.physicalLocation.address2 : ' ')                         
                        + (row.primaryAssisterSite.physicalLocation.city ? ', ' + row.primaryAssisterSite.physicalLocation.city  : ' ')
                        + (row.primaryAssisterSite.physicalLocation.state ? ', ' + row.primaryAssisterSite.physicalLocation.state : ' ')
                        + (row.primaryAssisterSite.physicalLocation.zip ? ', ' + row.primaryAssisterSite.physicalLocation.zip : ''  )) : '';
                        processedRow[headerName] = siteAddress;                        
                        break;                        
                    }
                    default: {
                        processedRow[headerName] = row[headerName] ? row[headerName] : '';
                        break;
                    }
                }
            }
            result.push(processedRow);
        });
        return result;
    };
    /**
     * Creates string of non empty filters values.
     * @param filters
     * @returns {any}
     */
    const constructQueryParams = filters => Object.keys(filters).map(key => filters[key] && `${key}=${filters[key].value}`).filter(Boolean).join('&');    

    useEffect(() => {
        actions.initAssisterFilters(filtersData);    
    }, []);    

    //const filterTypes = filterTypesByRole[roleGroup];
    const getDelegationViewProps = () => {
        return { 
            ...{
                isState,
                roleGroup,
                filters,            
                spinner, 
                pagination,
                pageNumber,
                firstPageLoad,
                onChangeHandler,
                onResetHandler,
                onApplyHandler,
                onPageNumberChange 
            },
            tableData: processedTableData(list),
            tableColumns: createTableHeaders(tableHeadersData)
        };
    };

    useEffect(() => {
        actions.fetchEntitySiteList(`${endpoints.ENTITY_SITE_LIST}`);
        //const params = constructQueryParams(filters);
        //const queryParams = params && `&${params}`;
        //actions.fetchAssisterData(`${endpoints.SEARCH_CEC.processReplacements({ pageNumber: 1 })}${queryParams}`);
    }, []);   

    return (
        <div id="entityContainer" className="usa-layout-docs usa-section gi-main-section entityContainer">
            <div className="grid-container grid-widescreen gi-grid-container">
                <div className="grid-row">
                    <NavBarContainer
                        navBarClass={!isState.CA ? 'grid-col-12 delegation-top-nav' : ''}
                        roleGroup={roleGroup}
                        arrayOfUserRoles={getAllowedUserRolesForNavBar()}
                    />
                </div>
                <div className="grid-row grid-gap">
                    <div className={`usa-layout-docs__main desktop:${containerWidth}`} id="main-content">
                        <AssisterList {...getDelegationViewProps()}/>                        
                    </div>
                </div>
            </div>
        </div>);
};

const mapStateToProps = state => ({
    spinner: state.common.spinner,
    environment: state.common.environment,
    entity: state.entity
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        fetchAssisterData,
        initAssisterFilters,
        setFilterValue,
        resetFilterValues,
        fetchNavBarData,
        exportAssisterBob,
        fetchEntitySiteList,
        setFilterFormState,
        setExportBtnState,
        setCurrentAssister
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EntityExportContainer);
